export default "__VITE_ASSET__a4853057__"